import { RecursosEnum } from "../enums/recusos";
import { RolesEnum } from "../enums/roles";
import { TipoClienteEnum } from "../enums/tipoCliente";

export type UserRole = `${RolesEnum}`;
export type UserRecurso = `${RecursosEnum}`;
export type UserType = `${TipoClienteEnum}`;

interface IUserStorageData {
  uuidUsuario: string;
  uuidCliente?: string;
  usuarioCpfCnpj?: string;
  nome?: string;
  tipo?: UserType;
  roles: UserRole[];
  recursos?: UserRecurso[];
}

export const useUserPermissions = () => {
  const getUserData = (): IUserStorageData | null => {
    try {
      const userData = localStorage.getItem("@usuarioMapa");
      if (!userData) {
        console.warn("Nenhum dado de usuário encontrado no localStorage");
        return null;
      }
      const parsed = JSON.parse(userData) as IUserStorageData;

      return parsed;
    } catch (error) {
      console.error("Erro ao fazer parse do usuário do localStorage:", error);
      return null;
    }
  };

  const userStorageData = getUserData();

  const hasRole = (role: UserRole): boolean => {
    const result = userStorageData?.roles?.includes(role) ?? false;

    return result;
  };

  const hasRecurso = (recurso: UserRecurso): boolean => {
    const result = userStorageData?.recursos?.includes(recurso) ?? false;

    return result;
  };

  const isUserType = (type: UserType): boolean => {
    return userStorageData?.tipo === type;
  };

  const isAdmin = (): boolean => {
    return hasRole(RolesEnum.ROLE_ADMIN);
  };

  const canResetPassword = (): boolean => {
    return hasRecurso(RecursosEnum.REDEFINIR_SENHA);
  };

  const hasAnyRole = (roles: readonly UserRole[]): boolean => {
    return roles.some((role) => hasRole(role));
  };

  const hasAnyRecurso = (recursos: readonly UserRecurso[]): boolean => {
    return recursos.some((recurso) => hasRecurso(recurso));
  };

  const hasAllRoles = (roles: readonly UserRole[]): boolean => {
    return roles.every((role) => hasRole(role));
  };

  const hasAllRecursos = (recursos: readonly UserRecurso[]): boolean => {
    return recursos.every((recurso) => hasRecurso(recurso));
  };

  return {
    userStorageData,
    hasRole,
    hasRecurso,
    isUserType,
    isAdmin,
    canResetPassword,
    hasAnyRole,
    hasAnyRecurso,
    hasAllRoles,
    hasAllRecursos,
  };
};
